import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import en from '@angular/common/locales/en';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NgxEchartsModule } from 'ngx-echarts';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatDividerModule } from '@angular/material/divider';
import { CalAngularModule } from '@cvx/cal-angular';
import { NextPage } from '@cvx/nextpage';
import player from 'lottie-web';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from 'src/environments/environment';
import { CoreModule } from './core/core.module';
import { RedirectGuard } from './core/services/RedirectGuard';
import { ClarificationQueryModule } from './modules/clarification-query/clarification-query.module';
import { NgZorroModule } from './ng-zorro.module';
import { UnAuthoriseComponent } from './pages/unauthorise/unauthorise.component';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { SharedModule } from './shared/shared.module';
import { AdminModule } from './modules/admin/admin.module';
import { ReportModule } from './modules/report/report.module';
import { NoAccessComponent } from './pages/no-access/no-access.component';


registerLocaleData(en);

@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        DateAgoPipe,
        UnAuthoriseComponent,
        NoAccessComponent,
        
    ],
    bootstrap: [AppComponent], 
    imports: [BrowserModule,
        NextPage,       
        AppRoutingModule,
        FormsModule,
        BrowserAnimationsModule,        
        ScrollingModule,        
        DragDropModule,        
        MatDividerModule,        
        CalAngularModule.forRoot(environment.calConfig),     
        NgxEchartsModule.forRoot({ echarts: () => import('echarts')}), 
        CoreModule,
        SharedModule,
        ClarificationQueryModule,
        NgZorroModule,
        AdminModule,
        ReportModule,
    ], 
    providers: [
        { provide: NZ_I18N, useValue: en_US },
        { provide: LocationStrategy, useClass: HashLocationStrategy }, // Enable Hash Location Strategy
        NzMessageService, 
        RedirectGuard,        
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
export function playerFactory() {
  return player;
}
